import { Box, Collapse, Stack } from '@mui/material';

import { PaymentInstrument } from '@ocx/data-payment-instruments';
import { SelectedStoreCard } from '@ocx-app/components/SelectedStoreCard/SelectedStoreCard';
import { ListSelector } from '@ocx-app/hooks/useListController';
import { IStoreCarWashOption } from '@ocx-app/modules/stores/types';
import { SizingMultiplier } from '@ocx/ui';

import backgroundLight from './assets/background-light.jpg';
import backgroundDark from './assets/background-dark.jpg';
import { PumpSelector } from './components/pump-selector/pump-selector.component';
import { PaymentSection } from './components/payment-section/payment-section.component';

type SelectPumpProps = {
  addressLine1: string;
  addressLine2: string;
  pumps: string[];
  selectedPump: string | null;
  selectPump(pump: string): void;
  shouldPrintReceipt: boolean;
  togglePrintReceipt(value?: boolean): void;
  handlePurchaseGooglePay(): void;
  handlePurchaseApplePay(): void;
  onAddPaymentMethodClick(): void;
  handlePurchaseCard(): void;
  deselectPump(): void;
  carWashListController: ListSelector<IStoreCarWashOption>;
  paymentInstrumentsListSelector: ListSelector<PaymentInstrument>;
  isPaymentInstrumentsLoading: boolean;
  isCardsAvailable: boolean;
};

export const SelectPump = (props: SelectPumpProps) => {
  const {
    addressLine1,
    addressLine2,
    pumps,
    selectPump,
    deselectPump,
    selectedPump,
    shouldPrintReceipt,
    togglePrintReceipt,
    handlePurchaseGooglePay,
    handlePurchaseApplePay,
    handlePurchaseCard,
    carWashListController,
    paymentInstrumentsListSelector,
    isPaymentInstrumentsLoading,
    onAddPaymentMethodClick,
    isCardsAvailable,
  } = props;

  return (
    <Stack
      flexGrow="1"
      sx={{
        background: (theme) =>
          `url(${theme.palette.retailerMode === 'light' ? backgroundLight : backgroundDark}) no-repeat center fixed`,
        backgroundSize: 'cover',
      }}>
      <Box m="auto 0" p={SizingMultiplier.lg}>
        <SelectedStoreCard addressLine1={addressLine1} addressLine2={addressLine2} />
      </Box>
      <Collapse in={selectedPump === null}>
        <PumpSelector pumps={pumps} selectPump={selectPump} />
      </Collapse>
      <Collapse in={selectedPump !== null} mountOnEnter>
        <PaymentSection
          carWashListController={carWashListController}
          paymentInstrumentsListSelector={paymentInstrumentsListSelector}
          isPaymentInstrumentsLoading={isPaymentInstrumentsLoading}
          selectedPump={selectedPump}
          shouldPrintReceipt={shouldPrintReceipt}
          togglePrintReceipt={togglePrintReceipt}
          handlePurchaseGooglePay={handlePurchaseGooglePay}
          handlePurchaseApplePay={handlePurchaseApplePay}
          onAddPaymentMethodClick={onAddPaymentMethodClick}
          handlePurchaseCard={handlePurchaseCard}
          deselectPump={deselectPump}
          isCardsAvailable={isCardsAvailable}
        />
      </Collapse>
    </Stack>
  );
};
